import 'moment-timezone';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function initCrashlytics() {
  try {
    if (Capacitor.isNativePlatform()) {
      return FirebaseCrashlytics.setEnabled({
        enabled: true,
      }).then(() => {
        console.log('Crashlytics enabled');
      });
    } else {
      return Promise.resolve(); // Return a resolved promise for non-native platforms
    }
  } catch (error) {
    console.error('Crashlytics initialization failed:', error);
    return Promise.reject(error); // Return a rejected promise in case of an error
  }
}

if (environment.production) {
  enableProdMode();
}

function initializeApp() {
  initCrashlytics() // Ensure this runs before Angular bootstraps
    .then(() => {
      return platformBrowserDynamic().bootstrapModule(AppModule);
    })
    .catch((err) => {
      console.error('Angular bootstrapping error', err);
      if (Capacitor.isNativePlatform()) {
        FirebaseCrashlytics.recordException({
          message: 'Angular bootstrapping error',
          stacktrace: err.stack,
        });
      }
    });
}

initializeApp();

declare global {
  interface Window {
    listenBluetoothHIDEvent: any;
  }
}
